
<template>    
 <section class="campaign">
  <Header :user="user" />
  <main class="main"  :class="{ 'expand-main' : isMenuCollapse }" >

    <div class="pt-2">
        <div class="col-12 px-2">
        <h3 class="ml-3">Subscribers</h3>
        
        <div v-if="loading" class="text-center mt-4">
          <LoadingSpinner />
        </div>

        <div v-else>
        <!-- Tabs -->
        <Tabs 
            :tabSelected="tabSelected" 
            :tabs="tabs" 
            @change="changeTab($event)" 
            class="mx-3"
        />

        <!-- Total -->
         <div class="col-12 text-left my-2 font-weight-bold">
          <span>Total:</span>
          <span class="ml-1">{{total}}</span>
         </div>

        <!-- Table -->
        <div class="card mt-3 p-4">
          <div class="table table-responsive thead-dark">
            <Table
            v-if="subscribers.length > 0"
            class="mx-2"
            :headers="headers"
            :cols="cols"
            :data="formattedSubscribers"
            :checkbox="false"
            :notselect="true"
            @openClient="openClient"
            @orderBy="orderBy"
            />
            <div v-else class="text-center mt-4">
            <p>{{  $t('lang.label.subscribers_emtpy') }}</p>
            </div>
          </div>
        </div>
        </div>
  </div>
</div>      
</main>
</section>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  import Header from "@/components/Header.vue";
  import Tabs from "@/components/Common/Tabs.vue";
  import Table from "@/components/Common/Table.vue";
  import Tooltip from "@/components/Common/Tooltip.vue";
  import LoadingSpinner from "@/components/LoadingSpinner.vue";
  import { clientsService } from "@/_services";
import { map } from "jquery";
import { set } from "core-js/core/dict";
  
  export default {
    components: {
      Header,
      Tabs,
      Table,
      Tooltip,
      LoadingSpinner,
    },
  
    computed: {
      ...mapState({
        isMenuCollapse: state => state.sidebar.isNavOpen,
        currentUser: (state) => state.authentication.user,
      }),
  
      user() {
        return this.$store.state.authentication.user;
      },
  
      formattedSubscribers() {
        
        const transformed = this.subscribers.map(subscriber => {
          // Format dates
          const signedOn = subscriber.signed_on 
            ? this.$options.filters.formatDate(subscriber.signed_on) 
            : null;
          const kickoff = subscriber.kickoff_date 
            ? this.$options.filters.formatDate(subscriber.kickoff_date) 
            : null;
          const launching = subscriber.launching_date 
            ? this.$options.filters.formatDate(subscriber.launching_date) 
            : null;
          const nextPaymentDate = subscriber.next_payment_date
            ? this.$options.filters.formatDate(subscriber.next_payment_date) 
            : null;
  
          // Format currency values (null → 0 for table display)
          const pricePerMeeting = subscriber.price_per_meeting != null && subscriber.price_per_meeting !== ''
            ? `€ ${parseFloat(subscriber.price_per_meeting).toFixed(2)}` 
            : '€ 0.00';          
          const subscriptionPrice = subscriber.subscription_price 
            ? `€ ${parseFloat(subscriber.subscription_price).toFixed(2)}` 
            : null;
          const bookerPrice = subscriber.subscription_booker_price != null && subscriber.subscription_booker_price !== ''
            ? `€ ${parseFloat(subscriber.subscription_booker_price).toFixed(2)}` 
            : '€ 0.00';
  
          // Calculate total recurring (subscription + bookers; + contacts price when contacts_active is 1)
          const subscriptionPriceNum = parseFloat(subscriber.subscription_price || 0);
          const bookerPriceNum = parseFloat(subscriber.subscription_booker_price || 0);
          const bookersNum = parseFloat(subscriber.bookers || 0);
          const baseRecurring = subscriptionPriceNum + (bookersNum * bookerPriceNum);
          const contactsPriceNum =
            Number(subscriber.contacts_active) === 1
              ? parseFloat(subscriber.contacts_price_per_month) || 0
              : 0;
          const totalRecurring = baseRecurring + contactsPriceNum;
  
          // Total recurring billable (0 if subscription is disabled)
          const subscriptionEnabled = (subscriber.subscription_enabled == "1") ? true : false // || subscriber.subscription_disabled === 1;
          const totalRecurringBillable = subscriber.subscription_enabled == 'yes' ? 0 : baseRecurring;
          const formated_amount = subscriber.amount != null && subscriber.amount !== '' ? `€ ${parseFloat(subscriber.amount).toFixed(2)}` : '€ 0.00';
  
          // CPI: normalize category for itemBadge and format score for "(0.82)" display
          const cpiCategory = subscriber.cpi_category || (subscriber.cpi_score != null ? this.cpiCategoryFromScore(Number(subscriber.cpi_score)) : null);
          const cpiCategoryNormalized = cpiCategory || '-';
          const cpiScoreFormatted = subscriber.cpi_score != null ? Number(subscriber.cpi_score).toFixed(2) : '';

          const currentMonthBase =
            (subscriber.first_month_offer == '1') || subscriber.subscription_enabled == 'yes' ? 0 : baseRecurring;
          const currentMonthTotal = currentMonthBase + contactsPriceNum;

          return {
            ...subscriber,
            signed_on_formatted: signedOn,
            kickoff_date_formatted: kickoff,
            launching_date_formatted: launching,
            price_per_meeting_formatted: pricePerMeeting,
            next_payment_date_formatted: nextPaymentDate,
            first_month_offer_formatted: subscriber.first_month_offer,
            subscription_price_formatted: subscriptionPrice, //(subscriber.subscription_enabled == 'yes') ? 0 : subscriptionPrice,
            booker_price_formatted: (subscriber.bookers == '0') ? '€ 0.00' : bookerPrice,
            total_recurring_formatted: `€ ${totalRecurring.toFixed(2)}`,// (subscriber.subscription_enabled == 'yes') ? 0 : `€ ${totalRecurring.toFixed(2)}`,
            current_month_recurring_formatted:
              currentMonthTotal === 0 ? '0' : `€ ${currentMonthTotal.toFixed(2)}`,
            total_recurring_billable_formatted: `€ ${totalRecurringBillable.toFixed(2)}`,
            subscription_enabled_bool: subscriptionEnabled,  
            formated_amount: formated_amount,
            cpi_category: cpiCategoryNormalized,
            cpi_score_formatted: cpiScoreFormatted,
          };

        });

        //////////////////////////////////

        const transformedToTotals = this.subscribers.map(subscriber => {
            
          // Calculate total recurring (same rules as per-row formatted columns)
          const subscriptionPriceNum = parseFloat(subscriber.subscription_price || 0);
          const bookerPriceNum = parseFloat(subscriber.subscription_booker_price || 0);
          const bookersNum = parseFloat(subscriber.bookers || 0);
          const baseRecurring = subscriptionPriceNum + (bookersNum * bookerPriceNum);
          const contactsPriceNum =
            Number(subscriber.contacts_active) === 1
              ? parseFloat(subscriber.contacts_price_per_month) || 0
              : 0;
          const totalRecurring = baseRecurring + contactsPriceNum;
  
          // Total recurring billable (0 if subscription is disabled)          
          const totalRecurringBillable = subscriber.subscription_enabled == 'yes' ? 0 : baseRecurring;
  
          // Valores numéricos para totales: igual que lo que se muestra en la tabla
          const totalRecurringNum = totalRecurring;
          const currentMonthRecurringNum =
            ((subscriber.first_month_offer == '1') || subscriber.subscription_enabled == 'yes' ? 0 : baseRecurring) +
            contactsPriceNum;

          return {
            ...subscriber,
            // signed_on_formatted: signedOn,
            // kickoff_date_formatted: kickoff,
            // launching_date_formatted: launching,
            price_per_meeting_formatted: subscriber.price_per_meeting ? parseFloat(subscriber.price_per_meeting).toFixed(2) :  0, 
            subscription_price_formatted: (subscriber.subscription_enabled == 'yes') ? 0 : parseFloat(subscriber.subscription_price).toFixed(2),
            booker_price_formatted: (subscriber.bookers == '0') ? 0 : subscriber.subscription_booker_price ? parseFloat(subscriber.subscription_booker_price).toFixed(2) : 0,
            total_recurring_formatted: `€ ${totalRecurring.toFixed(2)}`,
            total_recurring_billable_formatted: `€ ${totalRecurringBillable.toFixed(2)}`,
            total_recurring: totalRecurringNum,
            total_recurring_billable: subscriber.subscription_enabled == 'yes' ? 0 : totalRecurring,
            current_month_recurring_formatted: currentMonthRecurringNum.toFixed(2),
            total_amount: subscriber.amount ? parseFloat(subscriber.amount).toFixed(2) : 0,
          };

        });
        
        let subscription_price_formatted_total = 0;
        let price_per_meeting_total = 0;
        let price_per_meeting_total_empty = 0;
        let bookers_total = 0;
        let bookers_price_per_month_total = 0;
        let total_recurring_total = 0;
        let total_recurring_billable_total = 0;
        let totalRows = 0;
        let booker_price_formatted_total = 0;
        let total_subscriptions_invoiced =0;
        let total_current_month_recurring_formatted = 0;
        let total_amount = 0;
        
        transformedToTotals.forEach(element => {

            price_per_meeting_total += parseFloat(Number(element.price_per_meeting_formatted) || 0);

            price_per_meeting_total_empty += (element.price_per_meeting_formatted) ? 0 : 1;
            
            totalRows += 1;

            subscription_price_formatted_total += parseFloat(Number(element.subscription_price_formatted) || 0);

            bookers_total += parseFloat(Number(element.bookers) || 0);

            bookers_price_per_month_total += parseFloat(Number(element.bookers_price_per_month) || 0);
            
            total_recurring_total += parseFloat(Number(element.total_recurring) || 0);

            total_recurring_billable_total += parseFloat(Number(element.total_recurring_billable) || 0);
            booker_price_formatted_total += parseFloat(Number(element.booker_price_formatted))
            total_subscriptions_invoiced += parseFloat(Number(element.subscriptions_invoiced))

            total_current_month_recurring_formatted += parseFloat(Number(element.current_month_recurring_formatted))
            total_amount += parseFloat(Number(element.amount) || 0);
        });

        
        // Agrego fila de totales
        const divisor = totalRows - price_per_meeting_total_empty;
        
        const ltvAverage = totalRows > 0 ? total_amount / totalRows : 0;
        const totalsRow = {
            totalRow: true,
            client_name: "Total",
            cpi_category: '-',
            cpi_score_formatted: '',
            price_per_meeting_formatted: divisor > 0  ? `€ ${(price_per_meeting_total / divisor).toFixed(2)}` : '€ 0.00',
            subscription_price_formatted: `€ ${subscription_price_formatted_total.toFixed(2)}`,
            bookers: bookers_total,
            bookers_price_per_month: bookers_price_per_month_total,
            booker_price_formatted: `€ ${booker_price_formatted_total}`, // bookers_price_per_month_total,
            total_recurring_formatted:  `€ ${total_recurring_total.toFixed(2)}`,
            total_recurring_billable_formatted: `€ ${total_recurring_billable_total.toFixed(2)}`,
            subscriptions_invoiced:  (total_subscriptions_invoiced / totalRows).toFixed(2),
            current_month_recurring_formatted: `€ ${total_current_month_recurring_formatted.toFixed(2)}`,
            total_amount: `€ ${ltvAverage.toFixed(2)}`,
            formated_amount: `€ ${ltvAverage.toFixed(2)}`,
        };

      return [...transformed, totalsRow];
       
      },
    },
  
    data() {
      return {
        loading: true,
        tabSelected: 1,
        total: 0,
        tabs: {
          1: {
            id: 1,
            name: 'All',
          },
          2: {
            id: 2,
            name: 'Preparing',
          },
          3: {
            id: 3,
            name: 'Active',
          },
          4: {
            id: 4,
            name: 'Churned',
          },
        },
        subscribers: [],
        headers: [
          {
            label: 'Client',
            percentage: '10%',
            class: 'overflowhide',
          },
          {
            label: 'CPI',
            percentage: '10%',
            class: 'overflowhide',
          },
          {
            label: 'Status',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Account manager',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Subs activation date',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Kick-off',
            percentage: '8%',
            class: 'overflowhide',
            field: 'kickoff_date',
            order: 'ASC',
            orderby: false,
          },
          // {
          //   label: 'Last status date',
          //   percentage: '8%',
          //   class: 'overflowhide',
          // },
          {
            label: 'Subs stop date',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Price / meeting',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: "Next Payment Date",
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'First month offer',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Subscriptions invoiced',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Subscription status',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Subscription price',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Bookers',
            percentage: '6%',
            class: 'overflowhide',
          },
          {
            label: 'Booker price',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Contact option',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Contacts price',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'Current month recurring',
            percentage: '8%',
            class: 'overflowhide',
          },          
          {
            label: 'Total Recurring',
            percentage: '8%',
            class: 'overflowhide',
          },
          {
            label: 'LTV',
            percentage: '8%',
            class: 'overflowhide',
          },
          // {
          //   label: 'Total Recurring (billable)',
          //   percentage: '10%',
          //   class: 'overflowhide',
          // },
        ],
        cols: [
          // Client (with link)
          [
            {
              value_label: 'client_name',
              value_emit: 'client_id',
              class: 'text-primary cursor-pointer',
              type: 'emit',
              emit: 'openClient',
            },
          ],
          // CPI
          [
            {
              value: 'cpi_category',
              value2: 'cpi_score_formatted',
              type: 'itemBadge',
              class: 'badge badge-pill text-small',
              colors: [
                { id: 'Strategic', label: 'Strategic', bgColor: '#28a745', textColor: '#FFFFFF' },
                { id: 'Core', label: 'Core', bgColor: '#007bff', textColor: '#FFFFFF' },
                { id: 'Watch', label: 'Watch', bgColor: '#fd7e14', textColor: '#FFFFFF' },
                { id: 'Low Priority', label: 'Low Priority', bgColor: '#6c757d', textColor: '#FFFFFF' },
                { id: "Launching", label: "Launching", bgColor: "#6f42c1", textColor: "#FFFFFF" },
                { id: '-', label: '-', bgColor: '#e9ecef', textColor: '#6c757d' },
              ],
            },
          ],
          // Status
          [
            {
              value: "client_status_id",
              type: "itemBadge",
              class: "badge badge-pill text-small",
              colors: [
                {
                  id: "1",
                  label: "Proposal",
                  bgColor: "gray",
                  textColor: "#FFFFFF",
                },
                {
                  id: "2",
                  label: "Outdated",
                  bgColor: "orange",
                  textColor: "#FFFFFF",
                },
                {
                  id: "3",
                  label: "Preparing",
                  bgColor: "#FF8C00",
                  textColor: "#FFFFFF",
                },
                {
                  id: "4",
                  label: "Active",
                  bgColor: "green",
                  textColor: "#FFFFFF",
                },
                {
                  id: "5",
                  label: "Stand By",
                  bgColor: "#279CF5",
                  textColor: "#FFFFFF",
                },
                {
                  id: "6",
                  label: "Deleted",
                  bgColor: "red",
                  textColor: "#FFFFFF",
                },
                {
                  id: "7",
                  label: "Recovering",
                  bgColor: "#F5AD27",
                  textColor: "#FFFFFF",
                },
                {
                  id: "8",
                  label: "Pending Deleted",
                  bgColor: "red",
                  textColor: "#FFFFFF",
                },
                {
                  id: "9",
                  label: "Validation",
                  bgColor: "yellow",
                  textColor: "#000000",
                },
              ],
            },
          ],
          // Account manager
          [
          {
              value_label: 'account_manager',
              value_emit: 'account_manager_id',
              class: 'text-primary cursor-pointer',
              type: 'emit',
              emit: 'openUser',
            },
          ],
          // Signed on
          [
            {
              value: 'subs_activation_date',
            },
          ],
          // Kick-off
          [
            {
              value: 'kickoff_date_formatted',
            },
          ],
          // Last status date
          // [
          //   {
          //     value: 'last_status_date',
          //   },
          // ],
          // Launching
          [
            {
              value: 'subs_stop_date',
            },
          ],
          // Price / meeting
          [
            {
              value: 'price_per_meeting_formatted',
            },
          ],
          [
            {
              value: 'next_payment_date_formatted',
            },
          ],
          // First month offer
          [
            {
            value: "first_month_offer_formatted",
            show_text: "false",
            icons: [
                {
                  icon_if_value: "1",
                  icon_true: "fas fa-check-circle text-success",
                  //tooltip_true: "",
                },
                // {
                //   icon_if_value: "0",
                //   icon_true: "fas fa-ban text-danger",
                //   //tooltip_true: "",
                // },              
              ],
            }
          ],
          // Subscriptions invoiced
          [
            {
              value: 'subscriptions_invoiced',
            },
          ],
          // Subscription status
          [
            {    
              value_to_evaluate: 'subscription_enabled',
              value: "yes",
              icon_if_value_true: "icon-ban",
              withTooltip: true, 
              valueTooltip: "internal_details",
              format: "subscription_status", 
              type: "iconIfPipe",
            },
          ],          
          // Subscription price
          [
            {
              value: 'subscription_price_formatted',
            },
          ],
          // Bookers
          [
            {
              value: 'bookers',
            },
          ],
          // Booker price
          [
            {
              value: 'booker_price_formatted',
            },
          ],
          // Contact option
          [
            {
              value: 'contacts_active',
            },
          ],
          // Contacts price
          [
            {
              value: 'contacts_price_per_month',
            },
          ],
          // Current month recurring
          [
            {
              value: 'current_month_recurring_formatted',
            },
          ],          
          // Total Recurring
          [
            {
              value: 'total_recurring_formatted',
            },
          ],
          [
            {
              value: 'formated_amount',
            },
          ],
          // Total Recurring (billable)
          // [
          //   {
          //     value: 'total_recurring_billable_formatted',
          //   },
          // ],
          // Internal details (with tooltip if has data)
        ],
      };
    },
    methods: {
      ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
      }),
      setHeader() {
        this.setCurrentRoute({ page: "client-subscribers", label: "Subscribers" });
        this.setCurrentRouteChild({ child: "" });
      },
      changeTab(tabId) {
        if (tabId === this.tabSelected) return;
        this.tabSelected = tabId;
        this.loadSubscribers();
      },
  
      getStatusIdsForTab(tabId) {
        const statusMap = {
          1: [1], // Proposal
          2: [3, 9], // Preparing
          3: [4,7], // Active
          4: [4, 5, 6, 7], // Churned
        };

        if(tabId == 1) {
          return '0'
        } else {
          return statusMap[tabId] || [1];
        }        
      },
  
      loadSubscribers() {
        this.loading = true;
        const statusIds = this.getStatusIdsForTab(this.tabSelected);

        const pauseSubscription = this.tabSelected == 4 ? 1 : 0;
        
        
        clientsService.getSubscribers(statusIds, pauseSubscription)
          .then((res) => {
            if (!res.error && res.result) {
              this.subscribers = res.result.items;
              this.total = res.result.total
            } else {
              this.subscribers = [];
            }
            this.loading = false;
          })
          .catch((err) => {
            console.error('Error loading subscribers:', err);
            this.subscribers = [];
            this.loading = false;
          });
      },
  
      cpiCategoryFromScore(score) {
        if (score >= 0.7) return 'Strategic';
        if (score >= 0.5) return 'Core';
        if (score >= 0.25) return 'Watch';
        return 'Low Priority';
      },

      orderBy(event) {
        if (!event || event.field !== 'kickoff_date') return;

        const direction = event.order === 'DESC' ? -1 : 1;
        this.subscribers = [...this.subscribers].sort((subscriberA, subscriberB) => {
          const kickoffA = subscriberA.kickoff_date || '';
          const kickoffB = subscriberB.kickoff_date || '';

          if (!kickoffA && !kickoffB) return 0;
          if (!kickoffA) return 1;
          if (!kickoffB) return -1;

          return kickoffA.localeCompare(kickoffB) * direction;
        });

        const kickoffHeader = this.headers.find(
          header => header.field === event.field
        );
        if (kickoffHeader) {
          kickoffHeader.order = event.order === 'ASC' ? 'DESC' : 'ASC';
        }
      },

      openClient(clientId) {
        const url = `/clients/${clientId}`;
        window.open(url, '_blank');
      },

      openUser(user_id) {
      let url = "/users/" + user_id;
      window.open(url, "_blank");
    },
    },
  
    mounted() {
      this.loadSubscribers();
      this.setHeader();
    },
  };
  </script>
  
  <style scoped>
  .container {
    padding: 20px;
  }
  </style>
  
